import styled from 'styled-components';

export default styled.div`
  min-width: 200px;
  max-width: calc(100% - 110px);
`;
